<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" @submit.native.prevent class="demo-form-inline h-formBorder" style="margin-left:-0.5rem">
                                <el-form-item label="套机号/名称" style="width: 55%;">
                                    <el-input clearable v-model="q.keyword"></el-input>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut" style="margin-top:-11px;width: 40%;">
                                    <el-button type="primary"  @click="handleFilter">搜索</el-button>
									<el-button type="primary"  @click="choseSelected">选择</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
								:border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="productCode"
                                    label="套机号"
                                    width=""
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="productName"
                                    label="套机名称"
                                    width=""
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <!-- <el-table-column
                                    prop="dwcode"
                                    label="单位编码"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="dwname"
                                    label="单位名称"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="jizhj"
                                    label="基准价"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="djyxq"
                                    label="有效期"
                                    width="110">
                            </el-table-column> -->

                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="querypage"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        name: "alluser",
        data(){
          return {
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  keyword:null,
                  usercode:null,
                  ddlx:null,
				  logincode:null,
              },
              ttdata:null,
              lists:[]
          }
        },
        methods: {
            handleFilter(){
                this.querypage();
            },
            querypage(p){
                ss.wuliaoselect.selectTaojiPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            handleSelectionChange(lists){
                if(this.oneflag){
                    this.$emit('choseObj', lists[0])
                }else{
                    this.lists = lists;
                }
            },
			choseSelected(){
			    this.$emit('choseObj', this.lists)
			},
        },
        created(){
            if(this.UserCode){
                this.q.usercode = this.UserCode
                //订单类型
                this.q.ddlx = this.dingdLeix
				this.q.logincode = this.logincode
                this.querypage()
            }
        },
        computed: {
            UserCode:function () {
                return this.usercode;
            },
            //订单类型
            dingdLeix:function () {
                return this.ddlx
            },
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            usercode:{
                type:String,
            },
            //订单类型
            ddlx:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
			logincode:{
				type:String,
			}
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
